import { gameState, config } from '@js/state';
import {
  enablePointerEvents,
  disablePointerEvents,
} from '@utils/pointer-events-control';

export default class GameScene extends Phaser.Scene {
  constructor() {
    super({ key: 'GameScene' });
  }

  preload() {}

  create() {
    enablePointerEvents();

    this.scene.launch('HintScene');

    gameState.cam = this.cameras.main;

    this.answers = [2, 2, 2, 1, 1, 1, 3, 2, 2, 2, 3];
    gameState.questionNumber = 0;

    const r5 = this.add
      .rectangle(0, 0, 1280, 720, 0xffffff)
      .setOrigin(0)
      .setDepth(15)
      .setAlpha(1);

    this.tweens.add({
      targets: r5,
      alpha: 0,
      duration: 500,
      ease: 'Sine.easeInOut',
    });

    this.createAnims();
    this.setUp();
  }

  createAnims() {
    this.anims.create({
      key: 'gemCorrect',
      frames: this.anims.generateFrameNames('gemCorrectAnim', {
        start: 0, end: 103, zeroPad: 0, prefix: 'gemCorrect', suffix: '.png',
      }),
      frameRate: 24, repeat: 0,
    });

    this.anims.create({
      key: 'gemShut',
      frames: this.anims.generateFrameNames('gemShutNormalAnim', {
        start: 0, end: 12, zeroPad: 0, prefix: 'gemShut', suffix: '.png',
      }),
      frameRate: 24, repeat: 0,
    });

    this.anims.create({
      key: 'burst',
      frames: this.anims.generateFrameNames('bubbleBurstAnim', {
        start: 22, end: 30, zeroPad: 0, prefix: 'bubbleBurst', suffix: '.png',
      }),
      frameRate: 24, repeat: 0,
    });

    this.anims.create({
      key: 'gemWrong',
      frames: this.anims.generateFrameNames('gemWrongAnim', {
        start: 0, end: 64, zeroPad: 0, prefix: 'gemWrong', suffix: '.png',
      }),
      frameRate: 24, repeat: 0,
    });

    this.anims.create({
      key: 'gemWrongOpen',
      frames: this.anims.generateFrameNames('gemWrongOpenAnim', {
        start: 0, end: 15, zeroPad: 0, prefix: 'gemWrongOpen', suffix: '.png',
      }),
      frameRate: 24, repeat: 0,
    });

    this.anims.create({
      key: 'jidle',
      frames: this.anims.generateFrameNames('jiggiIdleAnim', {
        start: 0, end: 144, zeroPad: 0, prefix: 'jiggiIdle', suffix: '.png',
      }),
      frameRate: 24, repeat: -1,
    });

    this.anims.create({
      key: 'jwrong',
      frames: this.anims.generateFrameNames('jiggiWrongAnim', {
        start: 0, end: 95, zeroPad: 0, prefix: 'jiggiWrong', suffix: '.png',
      }),
      frameRate: 30, repeat: 0,
    });

    this.anims.create({
      key: 'jswim',
      frames: this.anims.generateFrameNames('jiggiSwimAnim', {
        start: 0, end: 57, zeroPad: 0, prefix: 'jiggiSwim', suffix: '.png',
      }),
      frameRate: 24, repeat: -1,
    });

    this.anims.create({
      key: 'jswimfull',
      frames: this.anims.generateFrameNames('jiggiSwimAnim', {
        start: 0, end: 116, zeroPad: 0, prefix: 'jiggiSwim', suffix: '.png',
      }),
      frameRate: 24, repeat: 0,
    });

    this.anims.create({
      key: 'jswimidle',
      frames: this.anims.generateFrameNames('jiggiSwimAnim', {
        start: 9, end: 0, zeroPad: 0, prefix: 'jiggiSwim', suffix: '.png',
      }),
      frameRate: 24, repeat: 0,
    });
  }

  setUp() {
    this.panX = 1280;

    for (let i = 0; i < 11; i++) {
      this.add.image(0 + 1280 * i, 0, 'sbg').setOrigin(0);

      this.time.delayedCall(7000, () => {
        this.add
          .sprite(400 + 1280 * i, 0, 'bubbleOne')
          .setOrigin(0)
          .setAlpha(0.3)
          .setScale(0.5)
          .play('bub');
      });

      this.time.delayedCall(2000, () => {
        this.add
          .sprite(800 + 1280 * i, 0, 'bubbleOne')
          .setOrigin(0)
          .setAlpha(0.5)
          .setScale(0.7)
          .play('bub');
      });
    }

    this.fish = this.add.image(1280, 148, 'fish').setOrigin(0);

    this.tweens.add({
      targets: this.fish,
      x: {
        getStart: () => (gameState.correct + 1) * 1280,
        getEnd: () => gameState.correct * 1280 - 150,
      },
      duration: 24000,
      repeat: -1,
      repeatDelay: 4000,
    });

    const postFxPlugin = this.plugins.get('rexwarppipelineplugin');

    for (let i = 0; i < 11; i++) {
      this.add.image(0 + 1280 * i, 0, 'sbg4').setOrigin(0);
      this.time.delayedCall(5000, () => {
        this.add
          .sprite(0 + 1280 * i, 0, 'bubbleOne')
          .setOrigin(0)
          .setAlpha(0.5)
          .setScale(0.8)
          .play('bub');
      });

      this.add.image(0 + 1280 * i, 0, 'sbg5').setOrigin(0);

      this.gweed = this.add.image(1152 + 1280 * i, 420, 'gweed').setOrigin(0);
      if (postFxPlugin) {
        postFxPlugin.add(this.gweed, {
          speedY: 0.5, frequencyX: 20, frequencyY: 20,
          amplitudeX: 1.5, amplitudeY: 1, speedX: 2,
        });
      }

      this.gweed2 = this.add.image(11 + 1280 * i, 385, 'gweed2').setOrigin(0);
      if (postFxPlugin) {
        postFxPlugin.add(this.gweed2, {
          speedY: 0.5, frequencyX: 20, frequencyY: 20,
          amplitudeX: 1.5, amplitudeY: 1, speedX: 2,
        });
      }
    }

    this.overlay = this.add.image(0, 0, 'overlay').setOrigin(0).setAlpha(0);

    this.gem1 = this.add
      .sprite(584 - 187, 374 - 196, 'gemWrongOpenAnim')
      .setOrigin(0)
      .setInteractive({ cursor: 'pointer', pixelPerfect: true });
    this.gem2 = this.add
      .sprite(718 - 187, 405.5 - 196, 'gemWrongOpenAnim')
      .setOrigin(0)
      .setInteractive({ cursor: 'pointer', pixelPerfect: true });
    this.gem3 = this.add
      .sprite(852 - 187, 443.5 - 196, 'gemWrongOpenAnim')
      .setOrigin(0)
      .setInteractive({ cursor: 'pointer', pixelPerfect: true });
    this.gem4 = this.add
      .sprite(986 - 187, 483.5 - 196, 'gemWrongOpenAnim')
      .setOrigin(0)
      .setInteractive({ cursor: 'pointer', pixelPerfect: true });
    this.gems = [this.gem1, this.gem2, this.gem3, this.gem4];

    this.gem1.disableInteractive();
    this.gem2.disableInteractive();
    this.gem3.disableInteractive();
    this.gem4.disableInteractive();

    this.gemclick();

    this.jiggi = this.add
      .sprite(-500, 0, 'jiggiIdleAnim')
      .setOrigin(0)
      .play('jswim')
      .setDepth(5);

    this.tweens.add({
      targets: this.jiggi,
      x: 0,
      duration: 2375,
      repeat: 0,
      onComplete: () => {
        this.jiggi.anims.play('jswimidle', true).on('animationcomplete', () => {
          this.jiggi.play('jidle');
        });

        this.time.delayedCall(600, () => {
          this.overlay.setAlpha(1);
        });

        this.time.delayedCall(1200, () => {
          this.openGems();
        });
      },
    });
  }

  openGems() {
    this.gem1.play('gemWrongOpen');
    this.gem2.play('gemWrongOpen');
    this.gem3.play('gemWrongOpen');
    this.gem4.play('gemWrongOpen');

    const scene2 = this.scene.get('HintScene');

    if (gameState.correct == 0) {
      scene2.changeText();

      this.time.delayedCall(600, () => {});
    } else {
      if (gameState.correct < 6 && gameState.questionNumber < 10) {
        scene2.textHolderTween(1002, 500, 50);
      }
      this.time.delayedCall(600, () => {
        this.gem1.setInteractive();
        this.gem2.setInteractive();
        this.gem3.setInteractive();
        this.gem4.setInteractive();
      });
    }

    this.bubbleY = 102;
    this.bubble1 = this.add
      .image(gameState.correct * 1280 + 658, 270 + this.bubbleY, 'bubble')
      .setOrigin(0, 1).setScale(0).setDepth(1);
    this.bubble2 = this.add
      .image(gameState.correct * 1280 + 792, 301 + this.bubbleY, 'bubble')
      .setOrigin(0, 1).setScale(0).setDepth(1);
    this.bubble3 = this.add
      .image(gameState.correct * 1280 + 926, 340 + this.bubbleY, 'bubble')
      .setOrigin(0, 1).setScale(0).setDepth(1);
    this.bubble4 = this.add
      .image(gameState.correct * 1280 + 1060, 379 + this.bubbleY, 'bubble')
      .setOrigin(0, 1).setScale(0).setDepth(1);

    this.bubbles = [this.bubble1, this.bubble2, this.bubble3, this.bubble4];

    this.opt1 = this.add
      .image(gameState.correct * 1280 + 658, 270 + this.bubbleY, gameState.questionNumber + '_0')
      .setOrigin(0.5, 1).setScale(0).setDepth(1);
    this.opt2 = this.add
      .image(gameState.correct * 1280 + 792, 301 + this.bubbleY, gameState.questionNumber + '_1')
      .setOrigin(0.5, 1).setScale(0).setDepth(1);
    this.opt3 = this.add
      .image(gameState.correct * 1280 + 926, 340 + this.bubbleY, gameState.questionNumber + '_2')
      .setOrigin(0.5, 1).setScale(0).setDepth(1);
    this.opt4 = this.add
      .image(gameState.correct * 1280 + 1060, 379 + this.bubbleY, gameState.questionNumber + '_3')
      .setOrigin(0.5, 1).setScale(0).setDepth(1);

    this.opts = [this.opt1, this.opt2, this.opt3, this.opt4];

    this.bubfactorX = 50;
    this.bubfactorY = 50;

    this.bub1 = this.add
      .sprite(gameState.correct * 1280 + 658 + this.bubfactorX, 270 + this.bubbleY - this.bubfactorY, 'bubbleBurstAnim')
      .setDepth(1).setAlpha(0);
    this.bub2 = this.add
      .sprite(gameState.correct * 1280 + 792 + this.bubfactorX, 301 + this.bubbleY - this.bubfactorY, 'bubbleBurstAnim')
      .setDepth(1).setAlpha(0);
    this.bub3 = this.add
      .sprite(gameState.correct * 1280 + 926 + this.bubfactorX, 340 + this.bubbleY - this.bubfactorY, 'bubbleBurstAnim')
      .setDepth(1).setAlpha(0);
    this.bub4 = this.add
      .sprite(gameState.correct * 1280 + 1060 + this.bubfactorX, 379 + this.bubbleY - this.bubfactorY, 'bubbleBurstAnim')
      .setDepth(1).setAlpha(0);

    this.bubbles = [this.bubble1, this.bubble2, this.bubble3, this.bubble4];
    this.bubs = [this.bub1, this.bub2, this.bub3, this.bub4];

    this.tweens.add({
      targets: [this.bubble1, this.bubble2, this.bubble3, this.bubble4, this.opt1, this.opt2, this.opt3, this.opt4],
      scale: 1,
      duration: 500,
      delay: 1000,
      ease: 'Linear',
      onStart: () => {
        for (let i = 0; i < 4; i++) {
          this.tweens.add({
            targets: this.opts[i],
            x: this.opts[i].x + 47,
            y: this.opts[i].y - 16.5,
            duration: 450,
            ease: 'Linear',
          });
        }
      },
      onComplete: () => {
        this.highlight = this.add.image(722, 295, 'highlight').setAlpha(0).setOrigin(0).setDepth(1);

        this.tweens.add({
          targets: this.highlight,
          alpha: 1,
          duration: 300,
          ease: 'Linear',
          onComplete: () => {
            this.gem2.setInteractive();
          },
        });

        if (gameState.questionNumber == 0) {
          this.dummyOpt = this.add
            .image(gameState.questionNumber * 1280 + 792 + 47, 301 - 16.5 + this.bubbleY, gameState.questionNumber + '_1')
            .setOrigin(0.5, 1).setScale(1).setDepth(1);
        }
      },
    });
  }

  gemclick() {
    this.gem1.on('pointerdown', () => this.afterClick(0));
    this.gem2.on('pointerdown', () => this.afterClick(1));
    this.gem3.on('pointerdown', () => this.afterClick(2));
    this.gem4.on('pointerdown', () => this.afterClick(3));
  }

  afterClick(val) {
    if (gameState.questionNumber == 0) {
      this.overlay.setAlpha(0);
      this.highlight.setAlpha(0);
      this.dummyOpt.setTexture('0_1_c');
    }

    this.gem1.disableInteractive();
    this.gem2.disableInteractive();
    this.gem3.disableInteractive();
    this.gem4.disableInteractive();

    if (this.answers[gameState.questionNumber] == val + 1) {
      gameState.hintClose = true;
      this.opts[val].setTexture(gameState.questionNumber + '_' + val + '_c');
      this.bubbles[val].setTexture('bubble_c');
      gameState.correct++;

      const scene2 = this.scene.get('HintScene');
      scene2.clickCorrect();
      scene2.clickProgress();
      gameState.questionNumber++;

      this.gems[val].anims.play('gemCorrect');

      this.time.delayedCall(0, () => {
        this.jiggi.play('jswimfull');
      });

      let j = 0;
      for (let i = 0; i < 4; i++) {
        if (!(i == val)) {
          this.time.delayedCall(j, () => {
            this.gems[i].play('gemShut');
            this.bubs[i].play('burst').setAlpha(1);
            this.bubbles[i].setAlpha(0);
            this.opts[i].setAlpha(0);
          });
          j = j + 200;
        }
      }

      this.swimToGem(val);
      this.swimToNext();
    } else {
      this.jiggi.play('jwrong');
      this.bubbles[val].setTexture('bubble_w');
      this.gems[val].play('gemWrong');
      this.opts[val].setTexture(gameState.questionNumber + '_' + val + '_w');

      this.reattempt(val);
    }
  }

  swimToGem(val) {
    this.tweens.add({
      targets: this.jiggi,
      x: () => {
        if (val == 0) return 1280 * (gameState.correct - 1) + 325;
        else if (val == 1) return 1280 * (gameState.correct - 1) + 325 + 134;
        else if (val == 2) return 1280 * (gameState.correct - 1) + 325 + 268;
        else if (val == 3) return 1280 * (gameState.correct - 1) + 325 + 402;
      },
      y: () => {
        if (val == 0) return 100;
        else if (val == 1) return 130.5;
        else if (val == 2) return 169.5;
        else if (val == 3) return 209.5;
      },
      ease: 'sine.easeOut',
      duration: 3100,
      repeat: 0,
    });
  }

  swimToNext() {
    this.tweens.add({
      targets: this.jiggi,
      x: 1280 * gameState.correct,
      y: 0,
      ease: 'sine.easeOut',
      delay: 5500,
      duration: 2375,
      repeat: 0,
      onStart: () => {
        this.jiggi.play('jswim');
        const cam = this.cameras.main;
        if (gameState.correct <= 5 && gameState.questionNumber <= 9) {
          cam.pan(1280 * gameState.correct + 640, 360, 2375, 'Sine.easeInOut');
          gameState.attempts = 0;
        } else {
          this.time.delayedCall(2000, () => {
            if (gameState.correct >= 6) {
              const r5 = this.add
                .rectangle(1280 * (gameState.correct - 1), 0, 1280, 720, 0xffffff)
                .setOrigin(0)
                .setDepth(15)
                .setAlpha(0);

              this.tweens.add({
                targets: r5,
                alpha: 1,
                duration: 500,
                ease: 'Sine.easeInOut',
                onComplete: () => {
                  this.vid = this.add
                    .video(1280 * (gameState.correct - 1), 0, 'vid')
                    .setOrigin(0)
                    .setDepth(16)
                    .setLoop(false)
                    .play();

                  this.vid.on('complete', () => {
                    disablePointerEvents();
                    this.scene.launch('EndScene');
                    this.scene.pause('GameScene');
                    this.scene.pause('HintScene');
                  });
                },
              });
            } else {
              disablePointerEvents();
              this.scene.launch('EndScene');
              this.scene.pause('GameScene');
              this.scene.pause('HintScene');
            }
          });
        }
        this.gem1 = this.add
          .sprite(1280 * gameState.correct + 584 - 187, 374 - 196, 'gemWrongOpenAnim')
          .setOrigin(0)
          .setInteractive({ cursor: 'pointer', pixelPerfect: true });
        this.gem2 = this.add
          .sprite(1280 * gameState.correct + 718 - 187, 405.5 - 196, 'gemWrongOpenAnim')
          .setOrigin(0)
          .setInteractive({ cursor: 'pointer', pixelPerfect: true });
        this.gem3 = this.add
          .sprite(1280 * gameState.correct + 852 - 187, 443.5 - 196, 'gemWrongOpenAnim')
          .setOrigin(0)
          .setInteractive({ cursor: 'pointer', pixelPerfect: true });
        this.gem4 = this.add
          .sprite(1280 * gameState.correct + 986 - 187, 483.5 - 196, 'gemWrongOpenAnim')
          .setOrigin(0)
          .setInteractive({ cursor: 'pointer', pixelPerfect: true });

        this.gems = [this.gem1, this.gem2, this.gem3, this.gem4];

        this.gem1.disableInteractive();
        this.gem2.disableInteractive();
        this.gem3.disableInteractive();
        this.gem4.disableInteractive();
      },
      onComplete: () => {
        this.jiggi.play('jswimidle');
        this.openGems();
        this.gemclick();
      },
    });
  }

  reattempt(val) {
    const scene2 = this.scene.get('HintScene');
    scene2.clickWrong();

    gameState.attempts++;

    if (gameState.attempts < 3) {
      this.time.delayedCall(3000, () => {
        this.gems[val].play('gemWrongOpen');
      });

      this.time.delayedCall(3500, () => {
        for (let i = 0; i < 4; i++) {
          this.gems[i].setInteractive();
          this.bubbles[i].setTexture('bubble');
          this.opts[i].setTexture(gameState.questionNumber + '_' + i);
          gameState.hneed = true;
        }
      });
    } else {
      gameState.hintClose = true;

      this.time.delayedCall(3000, () => {
        scene2.objectFadeInOut(0, 1000, 250);

        for (let i = 0; i < 4; i++) {
          this.tweens.add({
            targets: [this.opts[i], this.bubbles[i]],
            alpha: 0,
            duration: 500,
            repeat: 0,
          });
          if (!(i == val)) {
            this.gems[i].play('gemShut');
          }
        }
      });

      gameState.questionNumber++;

      this.time.delayedCall(4000, () => {
        gameState.attempts = 0;
        this.openGems();
      });
    }
  }

  update() {}
}
